import React from "react";

export const TurtleIcon: React.FC = () => {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
      <g id="color">
        <path
          fill="#b1cc33"
          stroke="#b1cc33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m20.725 54.299-7.6415 0.68486c-1.5508 0.02674-3.1026 0.0535-2.8221-0.69574 0.2806-0.7492 2.3942-2.2742 3.2638-4.0529s0.49504-3.8121 1.0703-5.3512c0.5753-1.5391 2.1003-2.5826 3.6252-3.6259l4.3121-3.4877"
        />
        <path
          fill="#b1cc33"
          stroke="#b1cc33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m49.069 46.164 0.93729 4.0839c0.11633 0.7191 0.23247 1.437-0.07081 2.2369-0.30327 0.8-1.0256 1.6829-0.77093 2.1109 0.2548 0.42803 1.4855 0.40128 2.7153 0.37454l5.4534-0.47742-2.6472-11.622"
        />
        <path
          fill="#5c9e31"
          stroke="#5c9e31"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m54.352 39.57-24.731-2.7541-2.8103 7.1383 4.6544 1.7993c3.6935 1.0973 7.3857 2.1943 10.535 2.4791 3.1492 0.28474 5.7556-0.24225 8.3612-0.76909 2.2023-0.57679 5.4396-4.6161 5.4396-4.6161z"
        />
        <path
          fill="#b1cc33"
          stroke="#b1cc33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m32.282 35.123-2.9846 8.462c-1.0169 3.2649-2.0336 6.529-2.3409 8.5494s0.094 2.7963-2.2336 3.197c-2.3276 0.40075-7.3843 0.42751-8.4682-0.30839-1.084-0.7359 1.8055-2.2342 2.956-4.3205 1.1505-2.0863 0.56226-4.7602 1.1381-6.4198 0.5759-1.6597 2.3129-2.299 2.4872-3.2221 0.1742-0.9231-1.2163-2.1283-2.9694-2.9703s-3.8673-1.3192-4.9785-3.1922-1.2172-5.142-2.7004-7.0835-4.3473-2.5571-5.5921-4.3227-0.8702-4.6819 1.2374-5.9733c2.1076-1.2913 5.9472-0.95693 7.6321 0.22067s1.2167 3.1977 1.2772 5.131c0.0605 1.9334 0.64915 3.7795 1.2374 5.6245 0.52446 1.9573 2.1325 2.0094 3.1972 2.0441 2.3899-0.14965 3.2292-0.3003 5.6171-0.45195"
        />
        <path
          fill="#b1cc33"
          stroke="#b1cc33"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m57.33 37.49-4.8089 2.5654s-0.35331 5.6935 0.4558 7.1414c0.55443 1.2145 1.1237 2.463 1.2437 3.8675 0.12004 1.4045-0.20092 2.9829 0.81641 3.7852 1.0173 0.8023 3.3731 0.82868 4.7773 0.58789s1.8578-0.74822 1.4883-2.4219c-0.36953-1.6737-1.5826-4.5598-2.7871-7.4238l2.9688-1.2031 4.8164-0.96289-3.291-1.8477z"
        />
        <path
          fill="#5c9e31"
          stroke="none"
          d="m58.678 42.528c2.6841-2.401 2.6116-8.287.99152-12.75s-4.7883-7.5021-9.4684-9.2152c-4.68-1.7131-10.872-2.0991-15.866-.83269-4.9949 1.2664-8.792 4.1852-10.727 5.9948-1.935 1.8097-2.0075 2.5092-1.5115 4.7407.49602 2.2315 1.5194 5.8505 5.6005 8.2432s10.617 3.2069 16.736 4.1719 11.561 2.0481 14.245-.35294z"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m17.98 28.495c-.58825-1.845-1.1769-3.6911-1.2374-5.6245-.06048-1.9333.40775-3.9534-1.2772-5.131s-5.5245-1.512-7.6321-.22067c-2.1076 1.2914-2.4822 4.2077-1.2374 5.9733s4.1089 2.3812 5.5921 4.3227c1.4832 1.9415 1.5892 5.2105 2.7004 7.0835 1.1112 1.873 3.2254 2.3502 4.9785 3.1922s3.1436 2.0472 2.9694 2.9703c-.17428.92308-1.9113 1.5624-2.4872 3.2221-.57584 1.6596.01241 4.3335-1.1381 6.4198-1.1505 2.0863-4.04 3.5846-2.956 4.3205 1.0839.7359 6.1406.70914 8.4682.30839 2.3276-.40074 1.9263-1.1766 2.2336-3.197s1.324-5.2845 2.3409-8.5494"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m18.221 41.258c-1.5249 1.0433-3.0499 2.0868-3.6252 3.6259-.57526 1.5391-.2007 3.5725-1.0703 5.3512s-2.9832 3.3037-3.2638 4.0529c-.28054.74924 1.2713.72248 2.8221.69574"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m52.977 47.197c.55443 1.2145 1.1243 2.4627 1.2443 3.8672.12004 1.4045-.20102 2.983.81631 3.7853 1.0173.8023 3.3718.82906 4.776.58827s1.859-.74914 1.4895-2.4228c-.36953-1.6737-1.5831-4.5593-2.7876-7.4233"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m51.88 54.97c-1.2298.02674-2.4605.05349-2.7153-.37454-.25472-.42804.46766-1.3109.77093-2.1109.30328-.79994.18714-1.5178.07081-2.2369"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m31.465 45.753c3.6935 1.0973 7.3857 2.1943 10.535 2.4791 3.1492.28474 5.7556-.24225 8.3612-.76909"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m58.678 42.528c2.6841-2.401 2.6116-8.287.99152-12.75s-4.7883-7.5021-9.4684-9.2152c-4.68-1.7131-10.872-2.0991-15.866-.83269-4.9949 1.2664-8.792 4.1852-10.727 5.9948-1.935 1.8097-2.0075 2.5092-1.5115 4.7407.49602 2.2315 1.5194 5.8505 5.6005 8.2432s10.617 3.2069 16.736 4.1719 11.561 2.0481 14.245-.35294z"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m63.01 41.579 3.291 1.8462-4.8161.96321"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m42.114 42.171 1.7027-11.749 8.7407-.96488 4.4839-3.6893"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m43.647 30.138-9.7056-5.9596"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m33.884 24.009-1.2487-3.3487"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m33.828 24.349-6.9244 12.941"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m52.898 30.082 4.4271 13.054"
        />
      </g>
    </svg>
  );
};
